import Prediction from 'lib/location/Locations/Prediction';
import promisify from './promisify';

// add more types if needed:
// https://developers.google.com/places/supported_types#table3
export const TYPE_REGIONS = ['(regions)'];

let googleAutocompleteService: google.maps.places.AutocompleteService;

const service = (): google.maps.places.AutocompleteService => {
  googleAutocompleteService =
    googleAutocompleteService || new google.maps.places.AutocompleteService();
  return googleAutocompleteService;
};

export default async function autocomplete({ query }: { query: string }): Promise<Prediction[]> {
  if (!query) {
    return [];
  }

  // https://developers.google.com/maps/documentation/javascript/reference/3.exp/places-widget#AutocompletionRequest
  const request = {
    input: query,
    types: ['(regions)'],
    componentRestrictions: { country: 'us' },
  };

  const getPredictionsPromisified = promisify<
    [google.maps.places.AutocompletionRequest],
    google.maps.places.AutocompletePrediction[]
  >(service().getPlacePredictions.bind(service()));

  const predictionsData = await getPredictionsPromisified(request);

  return (predictionsData || []).map((pred) => new Prediction(pred));
}
